<template>
	<div>
		<!-- Ideas -->
		<!-- <div>MediaPlayerPluginConfig</div>
    <div>Volume default lvl?</div>
    <div>muted?</div>
    <div>play on hover?</div>
    <div>Select media:</div> -->
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "MediaPlayerPluginConfig",
	setup() {
		return {};
	},
});
</script>
